import {Utilities} from '@shared/utilities/utilities.model';

export class LogisticsError {
	code: string;
	description: string;
	error: string;
	message: string;
	path: string;
	status: number;
	timestamp: string;

	constructor(model?: any | LogisticsError) {
		if (!Utilities.isVoid(model)) {
			if (!Utilities.isVoid(model.code)) {
				this.code = `${model.code}`;
			}
			this.description = model.description;
			this.error = model.error;
			this.message = model.message;
			this.path = model.path;
			this.status = model.status;
			this.timestamp = model.timestamp;
		}
	}
}

export enum LogisticsErrorCode {
	LOGISTICS_100000 = 'LOGISTICS_100000',
	LOGISTICS_100001 = 'LOGISTICS_100001',
	LOGISTICS_1000 = 'LOGISTICS_1000',
	LOGISTICS_1001 = 'LOGISTICS_1001',
	LOGISTICS_1002 = 'LOGISTICS_1002',
	LOGISTICS_1003 = 'LOGISTICS_1003',
	LOGISTICS_1004 = 'LOGISTICS_1004',
	LOGISTICS_1005 = 'LOGISTICS_1005',
	LOGISTICS_1006 = 'LOGISTICS_1006',
	LOGISTICS_1007 = 'LOGISTICS_1007',
	LOGISTICS_1008 = 'LOGISTICS_1008',
	LOGISTICS_1009 = 'LOGISTICS_1009',
	LOGISTICS_1010 = 'LOGISTICS_1010',
	LOGISTICS_1011 = 'LOGISTICS_1011',
	LOGISTICS_1012 = 'LOGISTICS_1012',
	LOGISTICS_1013 = 'LOGISTICS_1013',
	LOGISTICS_1014 = 'LOGISTICS_1014',
	LOGISTICS_1015 = 'LOGISTICS_1015',
	LOGISTICS_1016 = 'LOGISTICS_1016',
	LOGISTICS_1017 = 'LOGISTICS_1017',
	LOGISTICS_1018 = 'LOGISTICS_1018',
	LOGISTICS_1019 = 'LOGISTICS_1019',
	LOGISTICS_1020 = 'LOGISTICS_1020',
	LOGISTICS_1021 = 'LOGISTICS_1021',
	LOGISTICS_1022 = 'LOGISTICS_1022',
	LOGISTICS_1023 = 'LOGISTICS_1023',
	LOGISTICS_1024 = 'LOGISTICS_1024',
	LOGISTICS_1025 = 'LOGISTICS_1025',
	LOGISTICS_1026 = 'LOGISTICS_1026',
	LOGISTICS_1027 = 'LOGISTICS_1027',
	LOGISTICS_1028 = 'LOGISTICS_1028',
	LOGISTICS_1029 = 'LOGISTICS_1029',
	LOGISTICS_1030 = 'LOGISTICS_1030',
	LOGISTICS_1031 = 'LOGISTICS_1031',
	LOGISTICS_1032 = 'LOGISTICS_1032',
	LOGISTICS_1033 = 'LOGISTICS_1033',
	LOGISTICS_1034 = 'LOGISTICS_1034',
	LOGISTICS_1035 = 'LOGISTICS_1035',
	LOGISTICS_1036 = 'LOGISTICS_1036',
	LOGISTICS_1037 = 'LOGISTICS_1037',
	LOGISTICS_1041 = 'LOGISTICS_1041',
	LOGISTICS_1042 = 'LOGISTICS_1042',
	LOGISTICS_1043 = 'LOGISTICS_1043',
	LOGISTICS_1044 = 'LOGISTICS_1044',
	LOGISTICS_1045 = 'LOGISTICS_1045',
	LOGISTICS_1046 = 'LOGISTICS_1046',
	LOGISTICS_1047 = 'LOGISTICS_1047',
	LOGISTICS_1050 = 'LOGISTICS_1050',
	LOGISTICS_1056 = 'LOGISTICS_1056',
	LOGISTICS_1065 = 'LOGISTICS_1065',
	LOGISTICS_1066 = 'LOGISTICS_1066',
	LOGISTICS_7030 = 'LOGISTICS_7030',
	LOGISTICS_2000 = 'LOGISTICS_2000',
	LOGISTICS_1070 = 'LOGISTICS_1070',
	LOGISTICS_1069 = 'LOGISTICS_1069',
	LOGISTICS_9001 = "LOGISTICS_9001",
	LOGISTICS_9002 = "LOGISTICS_9002",
	LOGISTICS_9003 = "LOGISTICS_9003",
	LOGISTICS_9004 = "LOGISTICS_9004",
	LOGISTICS_9005 = "LOGISTICS_9005"
}
